export default __webpack_public_path__ + "static/media/churn_assistance_personalized_dynamic_link.88a110f6.gif";